import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import ResetPassword from "../views/ResetPassword.vue";
import ForceChangePassword from "../views/ForceChangePassword.vue";
import Profile from "../views/Profile.vue";
import ModuleSelection from "../views/ModuleSelection.vue";
// DASHBOARD
import MyNotification from "../views/dashboards/MyNotification.vue";
import myTask from "../views/dashboards/myTask.vue";
// import myMcrTask from "../views/materialCatalogRequest/myMcrTask.vue";

// GENERAL LAYOUT
import searchByCharacteristic from "../views/generalLayout/New_searchByCharacteristic.vue";
import advanceSearchService from "../views/generalLayout/New_advanceSearchService.vue";
import searchMaterial from "../views/generalLayout/New_searchMaterial.vue";

//MANAGE ACCOUNT
import manageAccount from "../views/manageAccount/manageAccount.vue";
import manageAccountCreateAndEdit from "../views/manageAccount/manageAccountCreateAndEdit.vue";
import manageRole from "../views/manageAccount/manageRole.vue";
import manageRoleCreateAndEdit from "../views/manageAccount/manageRoleCreateAndEdit.vue";
import managePermission from "../views/manageAccount/managePermission.vue";

// GENERAL SETTING
import menu from "../views/generalSettings/manageMenu/menu.vue";
import subMenu from "../views/generalSettings/manageMenu/subMenu.vue";
import appConfiguration from "../views/generalSettings/settings/appConfiguration.vue";
// import mailTemplates from "../views/generalSettings/workflowApproval/mailTemplates.vue";
import queryTemplates from "../views/generalSettings/workflowApproval/queryTemplates.vue";
import scriptTemplates from "../views/generalSettings/workflowApproval/scriptTemplates.vue";
import workFlow from "../views/generalSettings/workflowApproval/workFlow.vue";
import editWorkflow from "../views/generalSettings/workflowApproval/editWorkflow.vue";
import notificationTemplates from "../views/generalSettings/workflowApproval/notificationTemplates.vue";
import WorkflowDiagram from "../views/generalSettings/workflowApproval/workflow/diagram.vue";

// REPORT
import activityLog from "../views/report/appAuditing/activityLog.vue";
import dataLog from "../views/report/appAuditing/dataLog.vue";
import transactionLog from "../views/report/appAuditing/transactionLog.vue";
import modelLog from "../views/report/appAuditing/modelLog.vue";
import checkDuplicate from "../views/report/checkDuplicate.vue";
import exsport from "../views/report/export.vue";
import weeklyReport from "../views/report/weeklyReport.vue";

// GENERAL MASTER DATA
import warehouses from "../views/generalMasterData/warehouses.vue";
import serviceGroups from "../views/generalMasterData/serviceGroups.vue";
import serviceCategories from "../views/generalMasterData/serviceCategories.vue";
import kimaps from "../views/generalMasterData/kimaps.vue";
import manufacturers from "../views/generalMasterData/manufacturers.vue";
import companies from "../views/generalMasterData/companies.vue";
import clients from "../views/generalMasterData/clients.vue";
import characteristics from "../views/generalMasterData/characteristics.vue";
import accountCategoryReferences from "../views/generalMasterData/accountCategoryReferences.vue";
// import abbreviations from "../views/generalMasterData/abbreviations.vue";
import plantLocation from "../views/generalMasterData/plantLocation.vue";
import orderType from "../views/generalMasterData/orderType.vue";
import activityType from "../views/generalMasterData/activityType.vue";
import priority from "../views/generalMasterData/priority.vue";
import costCenters from "../views/generalMasterData/costCenters.vue";
import workCenter from "../views/generalMasterData/workCenter.vue";
import plannerGroups from "../views/generalMasterData/plannerGroups.vue";
import functionalLocation from "../views/generalMasterData/functionalLocation.vue";
import orderTypeActifityType from "../views/generalMasterData/orderTypeActifityType.vue";
import priorityType from "../views/generalMasterData/priorityType.vue";
import glAccount from "../views/generalMasterData/glAccount.vue";
import vendor from "../views/generalMasterData/vendor.vue";
import customer from "../views/generalMasterData/customer.vue";
import GeneralMasterData from "../views/generalMasterData/generalMasterData.vue";

// DICTIONARY
import standardItemName from "../views/dictionary/standardItemName.vue";
import characteristic from "../views/dictionary/characteristic.vue";
import characteristicItemName from "../views/dictionary/characteristicItemName.vue";
import characteristicValue from "../views/dictionary/characteristicValue.vue";
import abbreviation from "../views/dictionary/abbreviation.vue";
import natoGroupClass from "../views/dictionary/natoGroupClass.vue";
import scopeofSupply from "../views/dictionary/scopeOfSupply.vue";
import smartcatAttachment from "../views/dictionary/smartcatAttachment.vue";
import unspsc from "../views/dictionary/unspsc.vue";

import manageAssets from "../views/assetsManagement/manageAssets.vue";

// Material Catalog Request
import draftList from "../views/materialCatalogRequest/draftList.vue";
import materialRequestList from "../views/materialCatalogRequest/materialList.vue";
// import editDraft from "../views/materialCatalogRequest/editDraft.vue";
import mcrForm from "../views/materialCatalogRequest/New_McrForm.vue";

//SAP
import masterDataSync from "../views/sap/masterDataSync.vue"
import sapConnection from "../views/sap/sapConnection.vue";
import sapSync from "../views/sap/sapSync.vue";
import sapSyncParam from "../views/sap/sapSyncParam.vue";
import sapSyncTask from "../views/sap/sapSyncTask.vue";

// FAQ
import faq from "../views/faq/faq.vue";
import faqDetail from "../views/faq/faqDetail.vue";

// Test
import test from "../views/Test.vue";
import AzureRedirect from "../views/AzureRedirect.vue";

const routes = [
  { path: "/login", name: "Login", component: Login },
  { path: "/forgot-password", name: "ForgotPassword", component: ForgotPassword },
  { path: "/reset-password", name: "ResetPassword", component: ResetPassword },
  { path: "/module-selection", name: "ModuleSelection", component: ModuleSelection },
  { path: "/force-change-password", name: "ForceChangePassword", component: ForceChangePassword },
  { path: "/callback", name: "SsoTicket", component: AzureRedirect },
  { path: "/azure-redirect", name: "AzureRedirect", component: AzureRedirect },

  {
    path: "/:moduleSlug?",
    children: [
      { path: "", redirect: (to) => `/${to.params.moduleSlug || "material-management"}/dashboards/my-task` },
      { path: "home", name: "Home", component: Home },
      { path: "profile", name: "Profile", component: Profile },

      // DASHBOARD
      { path: "dashboards/my-notification", name: "My Notification", component: MyNotification },
      { path: "dashboards/my-task", name: "My Task", component: myTask },
      // { path: "dashboards/my-mcr-task", name: "My MCR Task", component: myMcrTask },

      // MATERIAL CATALOG REQUEST
      { path: "material-catalog-request/draft-list", name: "Draft List", component: draftList },
      { path: "material-catalog-request/material-request-list", name: "Material Request List", component: materialRequestList,  },
      { path: "material-catalog-request/service-request-list", name: "Service Request List", component: materialRequestList, props: { serviceMode: true } },
      // { path: "material-catalog-request/edit-draft", name: "Edit Draft", component: editDraft },
      { path: "material-catalog-request/draft/:id/:action/:mcrCode", name: "MCR Form for Draft", component: mcrForm },
      { path: "material-catalog-request/material-request/:id/:action/:mcrCode", name: "MCR Form for Material Request", component: mcrForm, meta: { formMode: 'view', formCode: 'FORM02' } },
      { path: "material-catalog-request/my-task/:id/:action/:mcrCode", name: "MCR Form for My Task MCR", component: mcrForm },
      { path: "material-catalog-request/edit-sync-task/:id/:action/:mcrCode", name: "MCR Form for Edit Sync Task", component: mcrForm },

      // GENERAL-LAYOUT
      // Halaman search (lihat saja, tanpa MCR): form FORM02 + context pengganti yang dibaca New_searchPageMixin.
      // mcrType = mcr_type pengganti (config FORM02 memakai mcr_type di aturan tampil): material = MCR002, service = MCR009.
      // itemSource = sumber data detail (hydrate_from). companies (opsional) = company yang boleh membuka halaman ini.
      { path: "general-layout/search-material", name: "Search Material", component: searchMaterial, meta: { formMode: 'view', formCode: 'FORM02', itemSource: 'eu_material', mcrType: 'MCR002' } },
      { path: "general-layout/search-by-characteristic", name: "Search By Characteristic", component: searchByCharacteristic, meta: { formMode: 'view', formCode: 'FORM02', itemSource: 'eu_material', mcrType: 'MCR002' } },
      { path: "general-layout/advance-search-service", name: "Advance Search Service", component: advanceSearchService, meta: { formMode: 'view', formCode: 'FORM02', itemSource: 'eu_service', mcrType: 'MCR009', companies: ['INALUM'] } },

      // DICTIONARY
      { path: "dictionary/standard-item-name", name: "Standard Item Name", component: standardItemName },
      { path: "dictionary/characteristic-master/characteristic", name: "Characteristic", component: characteristic },
      { path: "dictionary/characteristic-master/characteristic-item-name", name: "Characteristic Item Name", component: characteristicItemName },
      { path: "dictionary/characteristic-master/characteristic-value", name: "Characteristic Value", component: characteristicValue },
      { path: "dictionary/abbreviation", name: "Abbreviation", component: abbreviation },
      { path: "dictionary/nato-group-class", name: "Nato Group Class", component: natoGroupClass },
      { path: "dictionary/scope-of-supply", name: "Scope of Supply", component: scopeofSupply },
      { path: "dictionary/smartcat-attachment", name: "Smartcat Attachment", component: smartcatAttachment },
      { path: "dictionary/Unspsc", name: "UNSPSC", component: unspsc },
      { path: "assets-management", name: "Manage Assets", component: manageAssets },

      // MANAGE ACCOUNT
      { path: "account-management/account-list", name: "Account List", component: manageAccount },
      { path: "account-management/manage-account/create", name: "Account List Create", component: manageAccountCreateAndEdit },
      { path: "account-management/manage-account/edit/:id", name: "Account List Edit", component: manageAccountCreateAndEdit },
      { path: "account-management/manage-role", name: "Manage Role", component: manageRole },
      { path: "account-management/manage-role/:action", name: "Manage Role Create", component: manageRoleCreateAndEdit },
      { path: "account-management/manage-role/:dataRoleCode/:action", name: "Manage Role Edit", component: manageRoleCreateAndEdit },
      { path: "account-management/permission", name: "Permission", component: managePermission },

      // GENERAL SETTING
      { path: "general-setting/manage-menu/menu", name: "Menu", component: menu },
      { path: "general-setting/manage-menu/submenu", name: "Sub Menu", component: subMenu },
      { path: "general-setting/app-configuration", name: "App Configuration", component: appConfiguration },
      { path: "general-setting/workflow-approval/workflow", name: "Workflow", component: workFlow },
      { path: "general-setting/workflow-approval/workflow/:id/edit", name: "Edit Workflow", component: editWorkflow },
      { path: "general-setting/workflow-approval/diagram/:wfcCode", name: "Workflow Diagram", component: WorkflowDiagram },
      { path: "general-setting/workflow-approval/notification-templates", name: "Notification Templates", component: notificationTemplates },
      { path: "general-setting/workflow-approval/script-templates", name: "Script Templates", component: scriptTemplates },
      { path: "general-setting/workflow-approval/query-templates", name: "Query Templates", component: queryTemplates },

      // REPORT
      { path: "report/app-auditing/activity-log", name: "Activity Log", component: activityLog },
      { path: "report/app-auditing/data-log", name: "Data Log", component: dataLog },
      { path: "report/app-auditing/transaction-log", name: "Transaction Log", component: transactionLog },
      { path: "report/app-auditing/model-log", name: "Model Log", component: modelLog },
      { path: "report/check-duplicate", name: "Check Duplicate", component: checkDuplicate },
      { path: "report/export", name: "Export", component: exsport },
      { path: "report/weekly-report", name: "Weekly Report", component: weeklyReport },

      // GENERAL MASTER DATA
      { path: "general-master-data/:resource", name: "general-master-data", component: GeneralMasterData, props: true },
      { path: "general-master-data/warehouses", name: "Warehouses", component: warehouses },
      { path: "general-master-data/service-groups", name: "Service Groups", component: serviceGroups },
      { path: "general-master-data/service-categories", name: "Service Categories", component: serviceCategories },
      { path: "general-master-data/kimaps", name: "KIMAP", component: kimaps },
      { path: "general-master-data/manufacturers", name: "Manufacturers", component: manufacturers },
      { path: "general-master-data/companies", name: "Companies", component: companies },
      { path: "general-master-data/clients", name: "Clients", component: clients },
      { path: "general-master-data/characteristics", name: "Characteristics", component: characteristics },
      { path: "general-master-data/account-category-references", name: "Account Category References", component: accountCategoryReferences },
      // { path: "general-master-data/abbreviations", name: "Abbreviations", component: abbreviations },
      { path: "general-master-data/plant-location", name: "Plant Location", component: plantLocation },
      { path: "general-master-data/order-type", name: "Order Type", component: orderType },
      { path: "general-master-data/activity-type", name: "Activity Type", component: activityType },
      { path: "general-master-data/priority", name: "Priority", component: priority },
      { path: "general-master-data/cost-centers", name: "Cost Centers", component: costCenters },
      { path: "general-master-data/work-center", name: "Work Center", component: workCenter },
      { path: "general-master-data/planner-groups", name: "Planner Groups", component: plannerGroups },
      { path: "general-master-data/functional-location", name: "Functional Location", component: functionalLocation },
      { path: "general-master-data/order-type-actifity-type", name: "Order Type Actifity Type", component: orderTypeActifityType },
      { path: "general-master-data/priority-type", name: "Priority Type", component: priorityType },
      { path: "general-master-data/gl-account", name: "GL Account", component: glAccount },
      { path: "general-master-data/vendor", name: "Vendor", component: vendor },
      { path: "general-master-data/customer", name: "Customer", component: customer },

      // SAP
      { path: "sap/master-data-sync", name: "Master Data Sync", component: masterDataSync },
      { path: "sap/sap-configuration", name: "SAP Configuration", component: sapSync },
      { path: "sap/sap-connection", name: "SAP Connection", component: sapConnection },
      { path: "sap/sap-sync-param/:sapSync", name: "SAP Sync Params", component: sapSyncParam },
      { path: "sap/sap-sync-task", name: "SAP Sync Task", component: sapSyncTask },

      // FAQ
      { path: "faq/faq-list", name: "FAQ List", component: faq },
      { path: "faq/:id", name: "FAQ Detail", component: faqDetail, meta: { breadcrumb: 'FAQ Detail' } },

      // TEST
      { path: "test", name: "test", component: test },
    ]
  },

  { path: "/", redirect: "/material-management/dashboards/my-task" },
  { path: "/:catchAll(.*)", redirect: "/material-management/dashboards/my-task" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active"
});

// Untuk melakukan pengecekan sebelum mengakses route, apakah sudah login atau belum
router.beforeEach((to, from, next) => {
  // Paksa akses ke /asset-management (path apapun di bawahnya) maupun /module-selection
  // (dengan/tanpa trailing slash) langsung ke dashboard, jangan pernah ke halaman ModuleSelection
  if (/^\/asset-management(\/|$)/.test(to.path) || /^\/module-selection\/*$/.test(to.path)) {
    return next('/material-management/dashboards/my-task');
  }

  const publicPages = ['Login', 'ForgotPassword', 'ResetPassword', 'ForceChangePassword', 'AzureRedirect', 'SsoTicket', 'ModuleSelection'];
  const authRequired = !publicPages.includes(to.name);
  const userAuthRaw = localStorage.getItem('userAuth');
  const userAuth = userAuthRaw ? JSON.parse(userAuthRaw) : null;
  const authenticated = userAuth?.authenticated;

  // Set dynamic page title
  const baseTitle = 'SmartCat';
  document.title = to.name ? `${to.name} - ${baseTitle}` : baseTitle;

  // Jika halaman yg diakses adalah yg mewajibkan autentikasi
  if (authRequired && !authenticated) {
    return next({
      name: 'Login',
      query: { redirect: to.fullPath }
    });
  }

  if (authenticated) {
    // Jika sudah ter autentikasi namun mengakses ke halaman login atau root maka diarahkan ke selection
    if (to.name == 'Login' || to.path === '/') {
      return next({
        name: 'ModuleSelection'
      });
    }
  }

  next();
})

export default router;
